var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 149,
    viewBox: "0 0 212 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6565:19103)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M135.58 46.2111C124.49 45.8279 92.2039 66.3457 82.1156 62.4523C72.0273 58.5589 71.6963 38.9233 60.8712 36.8694C53.9086 35.5426 45.947 35.3553 40.3365 39.0579C34.9385 42.6345 33.194 48.7914 32.2549 54.5088C31.5506 58.8127 31.1341 63.3396 33.0689 67.3676C34.4106 70.1641 36.7943 72.5145 38.4429 75.202C44.1768 84.5216 40.124 96.0144 33.9085 105.114C30.9953 109.382 27.6126 113.46 25.3626 118C23.1125 122.541 22.0723 127.749 24.0396 132.39C25.9915 136.989 30.6406 140.436 35.6753 142.863C45.9041 147.792 44.7108 148.103 56.4698 148.902C83.4196 148.902 108.631 148.902 151.229 148.902C160.883 148.618 167.322 149.667 176.819 148.183C182.093 147.359 187.539 146.051 191.368 142.904C196.228 138.896 197.432 132.109 194.176 127.085C188.713 118.656 173.612 116.561 169.789 107.516C167.687 102.537 169.846 96.9903 172.9 92.3731C179.453 82.4659 186.727 78.6918 187.307 67.3676C187.704 59.591 186.132 46.8872 177.969 43.2068C169.411 39.344 157.545 39.8294 151.236 46.2111C144.724 52.7733 145.372 46.5483 135.58 46.2111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6577 5.12646H31.7842V30.759H53.6577V5.12646Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.695 20.0789H90.8218V45.7114H112.695V20.0789Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.945 5.12646H150.071V30.759H171.945V5.12646Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6954 126.07L66.6493 126.023C68.301 125.826 69.7501 126.482 70.8794 127.776L64.6255 131.734C65.6913 128.352 66.6811 126.102 66.6954 126.07Z",
    fill: "#57B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0375 120.542L103.247 116.481C104.707 104.334 102.502 92.4746 98.7361 80.6812L66.5262 84.7426C71.3866 96.3125 72.8133 108.254 71.0375 120.542Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5516 87.45L94.2354 84.968L94.5019 87.0835L74.8182 89.5654L74.5516 87.45Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M72.1068 92.9656L98.7856 89.6016L98.9189 90.6593L72.2401 94.0233L72.1068 92.9656Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M72.5375 96.3828L99.2163 93.0188L99.3496 94.0765L72.6707 97.4405L72.5375 96.3828Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M72.9676 99.8003L99.6465 96.4363L99.7798 97.494L73.1009 100.858L72.9676 99.8003Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M73.3983 103.218L100.077 99.8535L100.21 100.911L73.5316 104.275L73.3983 103.218Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M73.8295 106.635L100.508 103.271L100.642 104.328L73.9627 107.692L73.8295 106.635Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M74.2596 110.052L100.938 106.688L101.072 107.746L74.3929 111.11L74.2596 110.052Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M74.6908 113.469L101.37 110.105L101.503 111.163L74.8241 114.527L74.6908 113.469Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2901 108.575L116.424 96.493C114.764 84.3714 109.63 73.4565 103.004 63L72.8697 75.0821C80.4986 85.0452 84.8996 96.2372 86.2901 108.575Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3195 75.6701L99.7349 68.2866L100.528 70.2658L82.1125 77.6492L81.3195 75.6701Z",
    fill: "#D0D7E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.3489 81.6251L105.309 71.6177L105.705 72.6072L80.7454 82.6146L80.3489 81.6251Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M81.6302 84.8221L106.59 74.8147L106.986 75.8043L82.0267 85.8116L81.6302 84.8221Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M82.9109 88.0191L107.871 78.0117L108.267 79.0013L83.3074 89.0087L82.9109 88.0191Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M84.1922 91.2161L109.152 81.2087L109.548 82.1983L84.5887 92.2057L84.1922 91.2161Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M85.4734 94.4134L110.433 84.406L110.83 85.3956L85.8699 95.4029L85.4734 94.4134Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M86.7542 97.6104L111.714 87.603L112.11 88.5926L87.1507 98.6L86.7542 97.6104Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M88.0354 100.807L112.995 90.8L113.392 91.7896L88.432 101.797L88.0354 100.807Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7424 111.485H126.207C129.174 99.6155 128.469 87.5736 126.207 75.4016H93.7424C97.1181 87.4888 97.0406 99.5151 93.7424 111.485Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.367 79.092H121.207V81.2242H101.367V79.092Z",
    fill: "#6B7482"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.2511 84.2585H125.141V85.3246H98.2511V84.2585Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.2511 87.7026H125.141V88.7687H98.2511V87.7026Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.2511 91.147H125.141V92.2131H98.2511V91.147Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.2511 94.5913H125.141V95.6574H98.2511V94.5913Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.2511 98.0356H125.141V99.1017H98.2511V98.0356Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.2511 101.48H125.141V102.546H98.2511V101.48Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.2511 104.924H125.141V105.99H98.2511V104.924Z",
    fill: "#6C63FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.625 104.282L126.81 95.5836C126.922 95.389 127.083 95.2272 127.277 95.1148C127.472 95.0023 127.692 94.9431 127.917 94.9431H133.953C134.292 94.9431 134.617 95.0777 134.856 95.3172C135.095 95.5567 135.23 95.8815 135.23 96.2203V149.516C135.23 150.615 134.794 151.668 134.017 152.445C133.24 153.222 132.187 153.658 131.089 153.658H69.1216C68.5778 153.658 68.0393 153.551 67.5368 153.343C67.0344 153.135 66.5779 152.83 66.1933 152.445C65.8088 152.06 65.5037 151.604 65.2956 151.101C65.0875 150.599 64.9804 150.06 64.9804 149.516V108.047C64.9804 107.048 65.3769 106.09 66.0828 105.384C66.7887 104.678 67.7461 104.282 68.7444 104.282H115.625Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.133 148.573H0.332031V149H183.133V148.573Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149 149H121L135 115L135.626 116.52L149 149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.304 80.6585C129.681 80.6585 131.608 78.7203 131.608 76.3293C131.608 73.9383 129.681 72 127.304 72C124.927 72 123 73.9383 123 76.3293C123 78.7203 124.927 80.6585 127.304 80.6585Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1705 85.3917C85.4445 85.3985 76.7789 83.9354 68.5334 81.0631C57.4793 77.2188 48.4235 71.9164 41.6178 65.303C28.744 52.793 18.1894 50.9077 11.6035 51.5285C4.47438 52.2008 0.324667 55.8728 0.283604 55.9098L0 55.5918C0.0418911 55.5539 4.27716 51.7986 11.5363 51.1058C15.7933 50.6998 20.245 51.4072 24.7681 53.2092C30.4086 55.4563 36.177 59.4219 41.9129 64.9957C48.6738 71.5656 57.677 76.8356 68.6721 80.6593C88.8568 87.6786 111.606 85.9791 131.086 75.9965C137.536 72.691 143.91 70.4348 150.033 69.2906C157.753 67.8473 165.074 68.1823 171.796 70.2856C186.565 74.9074 196.654 74.6623 202.516 73.6433C208.841 72.5436 211.711 70.3429 211.739 70.3208L212 70.658C211.881 70.7509 209.017 72.9465 202.588 74.0642C196.68 75.0916 186.519 75.3404 171.67 70.6934C156.634 65.9889 141.406 71.1872 131.279 76.3769C121.65 81.3373 111.137 84.3206 100.351 85.1529C98.2832 85.312 96.2232 85.3916 94.1705 85.3917Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2212 69.0687L45.9173 68.7703C47.3151 67.1761 48.3747 65.3117 49.031 63.2912C50.0643 60.1633 50.5691 55.2235 47.1053 49.4532C43.5614 43.5492 43.4019 38.7539 43.8921 35.7707C44.4256 32.5247 45.7865 30.7052 45.8442 30.6294L46.1817 30.8888C46.1681 30.9066 44.819 32.7164 44.307 35.8656C43.8344 38.7731 43.9993 43.4522 47.4689 49.2323C51.0212 55.1502 50.495 60.2272 49.4281 63.4441C48.272 66.9295 46.3045 68.983 46.2212 69.0687Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1523 30.9727H31.5718V0.213623H62.1523V30.9727ZM31.9965 30.5455H61.7276V0.640832H31.9965V30.5455Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.471 84.2344L105.167 83.9361C106.565 82.3419 107.625 80.4775 108.281 78.457C109.314 75.3291 109.819 70.3893 106.355 64.6189C102.811 58.715 102.652 53.9196 103.142 50.9365C103.676 47.6905 105.036 45.871 105.094 45.7952L105.432 46.0546C105.418 46.0724 104.069 47.8822 103.557 51.0314C103.084 53.9388 103.249 58.618 106.719 64.398C110.271 70.316 109.745 75.3929 108.678 78.6099C107.522 82.0954 105.554 84.1486 105.471 84.2344Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.402 46.1384H90.8218V15.3794H121.402V46.1384ZM91.2465 45.7112H120.978V15.8066H91.2465V45.7112Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.508 68.8551L164.204 68.5567C165.602 66.9624 166.662 65.098 167.318 63.0775C168.352 59.9497 168.856 55.0099 165.392 49.2396C161.848 43.3356 161.689 38.5402 162.179 35.5571C162.713 32.3111 164.074 30.4916 164.131 30.4158L164.469 30.6752C164.455 30.693 163.106 32.5028 162.594 35.652C162.121 38.5594 162.286 43.2386 165.756 49.0186C169.308 54.9366 168.782 60.0135 167.715 63.2304C166.559 66.7159 164.592 68.7693 164.508 68.8551Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.439 30.759H149.859V0H180.439V30.759ZM150.284 30.3318H180.015V0.427209H150.284V30.3318Z",
    fill: "#F0F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.631 9.18506H37.9429V9.61227H56.631V9.18506Z",
    fill: "#7788E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.631 13.8843H37.9429V14.3115H56.631V13.8843Z",
    fill: "#7788E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.631 18.5835H37.9429V19.0107H56.631V18.5835Z",
    fill: "#7788E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.456 23.7102H96.7681V24.1374H115.456V23.7102Z",
    fill: "#7788E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.456 28.4094H96.7681V28.8366H115.456V28.4094Z",
    fill: "#7788E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.456 33.1086H96.7681V33.5359H115.456V33.1086Z",
    fill: "#7788E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.493 9.18506H155.805V9.61227H174.493V9.18506Z",
    fill: "#7788E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.493 13.8843H155.805V14.3115H174.493V13.8843Z",
    fill: "#7788E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.493 18.5835H155.805V19.0107H174.493V18.5835Z",
    fill: "#7788E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.725 135.138C159.125 143.698 167.346 149 167.346 149C167.346 149 171.675 140.423 169.275 131.862C166.875 123.302 158.654 118 158.654 118C158.654 118 154.325 126.578 156.725 135.138Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.873 133.586C167.224 139.661 168 149 168 149C168 149 158.478 148.489 152.127 142.414C145.776 136.339 145 127 145 127C145 127 154.522 127.511 160.873 133.586Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6449 94.6809L58.9711 97.1063L39.2547 113.228C38.5297 114.124 38.0855 115.217 37.9781 116.367C37.8363 118.222 31.8788 127.924 34.0065 129.208C36.1341 130.492 43.7937 134.344 44.2193 131.776C44.6448 129.208 46.9143 118.222 46.9143 118.222L65.9214 101.101L64.6449 94.6809Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3754 129.635L39.9641 136.769C39.9641 136.769 42.5173 139.48 41.2407 141.763V149.61H39.2548L38.6875 145.472C38.6875 145.472 36.4256 149.557 35.2832 149.61C32.8883 149.719 28.1458 150.576 28.0039 149.292C27.8621 148.008 31.5953 146.756 31.5953 146.756L35.5669 135.77L37.269 129.065L42.3754 129.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3966 92.8263C79.3966 92.8263 80.6732 105.381 76.9852 107.664C73.2973 109.947 56.9852 117.223 56.9852 117.223C56.9852 117.223 63.9355 123.786 62.5171 125.356C61.0987 126.925 54.7157 131.205 53.8646 130.349C53.0135 129.493 43.51 119.221 44.6447 115.939C45.7795 112.658 61.5242 101.957 61.5242 101.957L63.3682 95.2517L63.9355 89.8302L69.893 85.978L79.3966 92.8263Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8981 63.5945C76.1639 63.5945 78.8114 60.9316 78.8114 57.6467C78.8114 54.3619 76.1639 51.699 72.8981 51.699C69.6323 51.699 66.9849 54.3619 66.9849 57.6467C66.9849 60.9316 69.6323 63.5945 72.8981 63.5945Z",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4819 60.0828C77.4819 60.0828 77.1982 65.5043 81.5953 67.2164C85.9925 68.9284 70.6733 80.0569 70.6733 80.0569V67.6444C70.6733 67.6444 72.6592 65.5043 70.6733 62.2229L77.4819 60.0828Z",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9146 85.5498L85.7799 91.114L82.3756 110.232C82.3756 110.232 85.2125 118.364 81.3827 118.222C77.5529 118.079 79.3969 109.376 79.3969 109.376L81.3827 93.5394V87.4045L86.9146 85.5498Z",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5171 82.8391L61.2405 87.8326L55.4249 101.957C55.4249 101.957 51.4532 108.663 54.7157 108.52C57.9781 108.377 57.9781 101.957 57.9781 101.957L64.6448 90.5434V84.1232L62.5171 82.8391Z",
    fill: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5244 124.5L66.2052 128.922C66.2052 128.922 69.4677 128.209 70.7442 132.061C72.0208 135.913 72.8719 138.339 72.8719 138.339L71.1698 139.337L69.0421 136.341C69.0421 136.341 67.7655 141.763 66.4889 142.191C65.2123 142.619 58.8293 145.472 59.3967 142.191L62.5173 137.625C62.5173 137.625 62.9428 132.489 61.6662 132.061C60.3896 131.633 56.9854 127.353 56.9854 127.353L61.5244 124.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5243 77.2035C71.5243 77.2035 75.3541 72.7806 76.4889 70.0698C77.2068 68.4265 78.5246 67.1231 80.1703 66.4287C80.1703 66.4287 88.6875 68.3578 88.5457 71.7819C88.4038 75.2061 83.1556 80.4849 83.1556 80.4849C83.1556 80.4849 83.8648 99.4603 80.035 99.175C79.2089 98.1833 78.6259 97.0105 78.3329 95.7508C77.9073 93.7534 64.7158 91.6133 64.7158 91.6133C64.7158 91.6133 63.5811 93.6108 63.4392 92.7547C63.2974 91.8987 64.574 70.9259 64.574 70.9259L71.3381 66.4287L71.5243 77.2035Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4531 70.4037L87.5481 70.4573C87.8512 70.6284 88.1036 70.8776 88.2792 71.1794C88.4548 71.4811 88.5474 71.8245 88.5473 72.1741L88.5459 82.7622C88.5469 83.05 88.6102 83.3342 88.7314 83.5949C88.8525 83.8556 89.0286 84.0867 89.2475 84.2721C89.7939 84.7396 90.3006 85.4132 89.2549 85.7638C87.5528 86.3345 80.8861 89.1879 80.7443 88.1892C80.6024 87.1905 80.3187 86.0492 80.7443 86.0492C81.0774 86.0492 83.0623 75.8184 84.6572 71.4441C84.7546 71.1763 84.9087 70.933 85.1088 70.731C85.3089 70.529 85.5503 70.3731 85.8162 70.2742C86.0821 70.1752 86.3662 70.1356 86.6488 70.1579C86.9314 70.1803 87.2058 70.2641 87.4531 70.4037V70.4037Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4891 70.4265L64.5033 70.9972L62.2338 80.8416C62.2338 80.8416 59.5387 81.4123 60.3898 82.411C61.2409 83.4097 64.787 85.9778 64.787 85.9778L66.4891 70.4265Z",
    fill: "#43D1B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6241 53.5C79.2019 53.5 79.8757 54.3866 80.1354 55.0757C80.1917 56.385 80.43 55.8574 80.1354 55.0757C80.1285 54.9131 80.1243 54.7222 80.1243 54.5C80.1243 50.9101 77.2141 48 73.6243 48C70.0344 48 67.1243 50.9101 67.1243 54.5C67.1243 55.666 68.8317 55.0837 70.3984 54.7976L72.6243 55C73.1485 55.5031 75.7325 54.2635 75.6245 55.5C75.4919 57.0181 76.6616 53.5 77.6241 53.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1245 53C76.3631 53 74.1245 50.7614 74.1245 48C74.1245 45.2386 76.3631 43 79.1245 43C81.8859 43 84.1245 45.2386 84.1245 48C84.1245 50.7614 81.8859 53 79.1245 53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1006 52.3653C82.5159 52.802 81.8385 53.0876 81.1251 53.1983C80.4116 53.309 79.6829 53.2415 78.9999 53.0015C78.3169 52.7616 77.6994 52.3561 77.1992 51.8189C76.6989 51.2818 76.3304 50.6287 76.1245 49.9143C76.2024 50.5545 76.408 51.1711 76.7281 51.7252C77.0483 52.2792 77.4762 52.7586 77.9847 53.1332C78.4933 53.5077 79.0714 53.7693 79.6827 53.9013C80.294 54.0333 80.9251 54.0329 81.5363 53.9001C82.1474 53.7674 82.7253 53.5051 83.2334 53.13C83.7415 52.7548 84.1688 52.2748 84.4883 51.7204C84.8079 51.166 85.0127 50.5491 85.0899 49.9088C85.1671 49.2684 85.1149 48.6185 84.9367 48C85.0379 48.8309 84.9209 49.6747 84.5978 50.4427C84.2747 51.2108 83.7576 51.8749 83.1006 52.3653V52.3653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.06 60.1148C74.4711 61.0756 75.3437 58.364 74.3829 55.7751C73.4222 53.1862 70.992 51.7003 73.5809 50.7395C76.1698 49.7788 79.0474 51.0987 80.0081 53.6876C80.9688 56.2766 79.6489 59.1541 77.06 60.1148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1245 54C68.9154 54 67.1245 56.433 67.1245 54.5C67.1245 52.567 68.9154 51 71.1245 51C73.3337 51 75.1245 52.567 75.1245 54.5C75.1245 56.433 73.3337 54 71.1245 54Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.304 80.6585C129.681 80.6585 131.608 78.7203 131.608 76.3293C131.608 73.9383 129.681 72 127.304 72C124.927 72 123 73.9383 123 76.3293C123 78.7203 124.927 80.6585 127.304 80.6585Z",
    fill: "#43D1B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6565:19103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 149,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.75f65a42.svg";
export { ForwardRef as ReactComponent };